import type { SVGProps } from 'react'

const SvgSingleSensorFilledOff = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fill='#1a1a1a'
      d='M12 2a1 1 0 0 0-1 1v1H8c-.36 0-.697.096-.988.262l3.277 3.277a2.99 2.99 0 0 1 2.658-.385A3 3 0 0 1 15 10c0 .637-.2 1.225-.54 1.71l3.278 3.276c.166-.291.262-.627.262-.986V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zM2.8 3.225a.95.95 0 0 0-.7.275q-.3.3-.287.713A.98.98 0 0 0 2.1 4.9L6 8.834V14a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5h.15l5.9 5.9q.3.3.7.287.4-.012.7-.287.3-.3.312-.713c.012-.413-.087-.512-.287-.712L3.5 3.5a.95.95 0 0 0-.7-.276z'
    />
  </svg>
)
export default SvgSingleSensorFilledOff
